import React, { Component } from "react";
import { DotLoader } from "react-spinners";

export default class LoadingPage extends Component {
  render() {
    return (
      <div style={{ margin: "auto", width: "100px", paddingTop: 200 }}>
        <DotLoader color="linen" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoadingPage.js